import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { InsetWrapper } from '../../CheckoutProcess/components/InsetWrapper';
import { ShippingAddress } from '../../CheckoutProcess/components/fields/ShippingAddress';
import { PaymentContext } from '../contexts/PaymentContext';
import { CreditCards } from './CreditCards';

export class WorldpayCreditCard extends Component {
  constructor(props) {
    super(props);
    this.checkout = null;
    this.state = {
      orderID: '',
      zip: '',
      address: {
        name: this.props.name,
        address: this.props.defaultAddress.address,
        address2: this.props.defaultAddress.address2,
        city: this.props.defaultAddress.city,
        state: this.props.defaultAddress.state,
        country: this.props.defaultAddress.country,
        zip: this.props.defaultAddress.zip,
        phone: this.props.phone,
      },
      useDeliveryAddress: true,
      loading: false,
    };
  }

  onZipChange = (e) => {
    let address = { ...this.state.address };
    address.zip = e.target.value;
    this.setState({ zip: e.target.value, address });
  };

  onAddressChange = (address) => {
    this.setState({ address });
  };

  onSuccess = () => {
    this.setState({ loading: false });
  };

  onError = () => {
    this.setState({ loading: false });
  };

  submitPayment = async (sessionState = null, t = null) => {
    if (this.state.loading !== true) {
      this.setState({ loading: true });
    }
    if (this.props.isFullyPaid) {
      return;
    }

    this.props.onPaymentInitiated();

    let payload = {
      name: this.state.address.name,
      number: '',
      expiration_month: '',
      expiration_year: '',
      security_code: '',
      ...this.state.address,
      amount: this.props.amount,
      email: this.props.email,
      tos_accepted: this.props.tosAccepted,
      captureMethod: this.props.captureMethod,
      emailOptOut: this.props.emailOptOut,
      leapOptIn: this.props.leapOptIn,
      card_token: sessionState,
      reservationToken: this.props.token,
    };

    if (this.props.createdNewAccount) {
      payload.sendAccountEmail = 1;
    }

    if (this.state.useDeliveryAddress) {
      this.props.setDeliveryAddress({ ...this.state.address });
    }

    if (!(await this.props.validateAndSaveDeliveryAddress(t))) {
      this.setState({ loading: false });
      return;
    }

    this.props.onPaymentSubmit(payload, { onSuccess: this.onSuccess, onError: this.onError });
  };

  componentDidMount() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let that = this;

    let worldpayScript = document.createElement('script');
    worldpayScript.src = this.props.jsUrl;
    worldpayScript.type = 'text/javascript';
    worldpayScript.async = false;
    worldpayScript.onload = () => {
      Worldpay.checkout.init(
        {
          id: this.props.gatewayKey,
          form: '#payment-submit-form',
          fields: {
            pan: {
              selector: '#card__input-number',
              placeholder: 'Card number',
            },
            cvv: {
              selector: '#card__input-cvc',
              placeholder: 'CVC',
            },
            expiry: {
              selector: '#card__input-date',
              placeholder: 'MM/YY',
            },
          },
          styles: {
            input: {
              color: 'black',
              'font-size': '.875rem',
              'font-family': 'Helvetica',
              'line-height': '1.42857143',
            },
            'input.is-valid': {
              color: 'green',
            },
            'input.is-invalid': {
              color: 'red',
            },
            'input.is-onfocus': {
              color: 'black',
            },
          },
          acceptedCardBrands: ['amex', 'diners', 'discover', 'jcb', 'maestro', 'mastercard', 'visa'],
        },
        function (error, checkout) {
          if (error) {
            that.setState({ loading: false });
            that.props.onPaymentFail([{ detail: error }]);
            return;
          }
          that.checkout = checkout;
        },
      );
    };

    document.getElementsByTagName('head')[0].appendChild(worldpayScript);
  }

  onUseDeliveryAddressChange = () => {
    this.setState({
      useDeliveryAddress: !this.state.useDeliveryAddress,
    });
  };

  renderDeliveryAddress() {
    if (this.props.deliveryOption.method_name === 'Mail' || this.props.hasDeliverableProducts) {
      return (
        <ShippingAddress
          address={this.props.deliveryAddress}
          onAddressChange={this.props.setDeliveryAddress}
          useShippingAddress={this.state.useDeliveryAddress}
          onUseShippingAddressChange={this.onUseDeliveryAddressChange}
        />
      );
    }

    return <div></div>;
  }

  render() {
    const inputStyle = { height: '44px', border: '1px solid #ccc', paddingLeft: '5px' };
    return (
      <PaymentContext.Consumer>
        {({ TranslationContext, LocalizedAddress }) => (
          <TranslationContext.Consumer>
            {(t) => (
              <section className="checkout-form__section">
                <h4 className="checkout-form__sub-heading checkout-form__credit-card__sub-heading">
                  <div className="flex-left">{t.t('checkout__credit_card_details')}</div>
                  <div className="flex-right">
                    <CreditCards acceptedCards={this.props.acceptedCards} />
                  </div>
                </h4>
                <form id="payment-submit-form" onSubmit={(e) => this.submitPayment(e, t)}>
                  <InsetWrapper>
                    <section id="card__input-number" style={inputStyle}></section>
                  </InsetWrapper>
                  <div className="row card__input-group">
                    <div className="col-sm-6">
                      <section id="card__input-date" style={inputStyle}></section>
                    </div>
                    <div className="col-sm-6">
                      <section id="card__input-cvc" style={inputStyle}></section>
                    </div>
                  </div>
                  <button
                    style={{ display: 'none' }}
                    id="payment-form-invisible-button"
                    onClick={(e) => this.onPaymentButtonClick(e, t)}
                    type="submit"
                  >
                    Invisible display button
                  </button>
                </form>
                <LocalizedAddress
                  {...this.state.address}
                  onAddressChange={this.onAddressChange}
                  header={t.t('checkout__billing_address')}
                />
                {this.renderDeliveryAddress()}
              </section>
            )}
          </TranslationContext.Consumer>
        )}
      </PaymentContext.Consumer>
    );
  }

  onPaymentButtonClick = (e, t) => {
    e.preventDefault();

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let that = this;
    this.checkout.generateSessionState(function (error, sessionState) {
      if (error) {
        that.setState({ loading: false });
        that.props.onPaymentFail([{ detail: error }]);
        return;
      }

      that.submitPayment(sessionState, t);
    });
  };
}

WorldpayCreditCard.propTypes = {
  onPaymentInitiated: PropTypes.func.isRequired,
  onPaymentSuccess: PropTypes.func.isRequired,
  onPaymentFail: PropTypes.func.isRequired,
  amount: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  name: PropTypes.string,
  phone: PropTypes.string,
  token: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  tosAccepted: PropTypes.bool.isRequired,
  acceptedCards: PropTypes.object,
  captureMethod: PropTypes.number,
  isFullyPaid: PropTypes.bool,
  createdNewAccount: PropTypes.bool,
  emailOptOut: PropTypes.bool,
  leapOptIn: PropTypes.bool,
  gatewayKey: PropTypes.string.isRequired,
  validateAndSaveDeliveryAddress: PropTypes.func.isRequired,
  setDeliveryAddress: PropTypes.func.isRequired,
  deliveryAddress: PropTypes.object.isRequired,
  deliveryOption: PropTypes.object,
  defaultAddress: PropTypes.object,
};

WorldpayCreditCard.defaultProps = {
  phone: '',
  name: '',
  acceptedCards: {},
  captureMethod: 1, // CAPTURE_ONLINE
  defaultAddress: {},
};

export default WorldpayCreditCard;
